/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { Menu, Input, Icon, Form } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import * as PageActions from 'catalog/actions/pages';
import { getAllPages, getFilter } from 'catalog/reducers/pages';

type Props = {
  currentFilter: string,
  pages: List<CatalogPage>,
  onFilter: (filter: string) => void,
};

const mapStateToProps = state => ({
  currentFilter: getFilter(state),
  pages: getAllPages(state),
});

const PagesMenu = ({ currentFilter, pages, onFilter }: Props) => {
  const filter = event => {
    onFilter(event.target.value);
  };

  return (
    <Menu.Menu position="right">
      <Menu.Item className="borderless">
        <Form>
          <Form.Field>
            <Input
              placeholder="Rechercher..."
              icon="search"
              iconPosition="left"
              value={currentFilter}
              onChange={filter}
            />
          </Form.Field>
        </Form>
      </Menu.Item>
      {(pages.size > 0 || currentFilter.length > 0) &&
        <Menu.Item>
          <Link to="/pages/new" className="ui primary labeled icon button">
            <Icon name="add" />
            Ajouter
          </Link>
        </Menu.Item>}
    </Menu.Menu>
  );
};

export default connect(mapStateToProps, {
  onFilter: PageActions.filterPages,
})(PagesMenu);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Pages/Menu.js